import { Component, Input, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';

@Component({
  selector: 'image-card',
  templateUrl: './image-card.component.html',
  styleUrls: ['./image-card.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class ImageCardComponent {

  @Input()
  images: Array<string>;

  private started: boolean = false;
  private current: number = 0;
  private currentElement: any;
  private _eventHandlers = {}; 
  constructor(private reloader: ChangeDetectorRef) { }

  private getStyle(index: number, url: string): any {
    return {
      'z-index': this.getZIndex(index),
      'background-image': 'url(\'' + url + '\')',
      'background-size': '100%'
    };
  }

  private swipe(index: number, event: any): void {
    if (!this.started) return;
    let Dx = event.deltaX;
    let sign = Dx < 0 ? -1 : 1;
    let angle = sign * Math.min((Math.abs(Dx) / 700) * 30, 30);

    this.currentElement.style.transform = "translate3d(" + event.deltaX + "px, " + event.deltaY + "px, 0px) rotateZ(" + angle + "deg)";

    if (Math.abs(event.deltaX) >= event.target.offsetWidth / 4) {
      Helpers.addClass(this.currentElement, 'dismiss');
    } else {
      Helpers.removeClass(this.currentElement, 'dismiss');
    }
    //console.log(event);
  }
  private startSwipe(index: number, event: any): void {
    this.started = true;
    this.current = index;
    this.currentElement = this.getSurroundingSwipeBox(event.target);
    Helpers.addClass(this.currentElement, 'dragging');
  }
  private endSwipe(index: number, event: any): void {
    if (!this.started) return;
    Helpers.removeClass(this.currentElement, 'dragging');
    if (Helpers.hasClass(this.currentElement, "dismiss")) {
      this.current = this.current || 0;
      this.current = this.current === this.images.length - 1 ? 0 : this.current + 1;
    }
    Helpers.addClass(this.currentElement, "dismiss"); // bei cancel auch animieren!
    Helpers.addClass(this.currentElement, "cancelled"); // bei cancel auch animieren!
    this.currentElement.style.transform = "translate3d(0px, 0px, 0px) rotateZ(0deg)";
    setTimeout(() => {
      Helpers.removeClass(this.currentElement, "dismiss");
      Helpers.removeClass(this.currentElement, "cancelled");
    }, 300);

    this.started = false;
  }

  private getSurroundingSwipeBox(el: any): any{
    let res = el;
    while(!Helpers.hasClass(res, 'swipe-box')){
      res = res.parentNode;
    }
    return res;
  }

  private getZIndex(index) {
    var res = 0;
    if (index === this.current) {
      res = 2000;
    } else if (this.current < index) {
      res = 2000 - (index - this.current);
    } else {
      res = 2000 - (this.images.length - 1 - this.current + index);
    }
    return res;
  }

  public normalizeIndex(index: number): number {
    let idx = index;
    while (idx < 0 || idx >= this.images.length) {
      if (idx < 0) {
        idx = this.images.length + idx;
      } else {
        idx = idx - this.images.length;
      }
    }
    return idx;
  }

  public getThumbList(): Array<number> {
    let list = new Array<number>();
    for (let i = this.current-2; i<this.current+3; i++) {
      let idx = this.normalizeIndex(i);
      list.push(idx);
    }
    return list;
  }

  public toLeft(): void {
    this.current = this.normalizeIndex(this.current - 1);
  }

  public toRight(): void {
    this.current = this.normalizeIndex(this.current + 1);
  }

  public goTo(index: number): void {
    console.log(index);
    this.current = index;
  }
}



// WEBPACK FOOTER //
// /home/artur/workspace/vscode/warpriders/src/app/content/libs/image-card/image-card.component.ts